import React from "react";
import { useNavigate } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";

const CongratulationsScreen = () => {
  const navigate = useNavigate();
  const handleBackToLogin = () => {
    navigate("/vendor-login");
  };

  return (
    <div className="min-h-screen bg-white flex flex-col px-6 py-8">
      <div className="flex-1" />
      <div className="mx-auto w-full max-w-md text-center">
        <h1 className="text-base font-semibold text-gray-800">
          Congratulations! Your details has been sent to our team... We'll let you
          know when your store is live.
        </h1>

        <div className="mt-8 flex flex-col items-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#A3E7C1]">
            <IoCheckmarkCircle className="h-16 w-16 text-[#19C463]" />
          </div>
          <p className="mt-4 text-lg font-bold text-gray-900">
            Congratulations
          </p>
        </div>

        <button
          type="button"
          onClick={handleBackToLogin}
          className="mt-10 w-full rounded-lg bg-[#19C463] py-3 text-sm font-semibold text-white transition-transform active:scale-[0.98]"
        >
          Back to Login
        </button>
      </div>
      <div className="flex-1" />
    </div>
  );
};

export default CongratulationsScreen;
